import { useOnClickOutside } from "hooks/useOnClickOutside";
import {
  homePath,
  pickemPath,
  matchesPath,
  tracksPath,
  tournamentsPath,
  aboutUsPath,
  communityPath,
} from "pages/PageConfigs";
import { useEffect, useRef, useState } from "react";
import {
  BurgerButton,
  BurgerMenuContainer,
  Menu,
  MenuContainer,
  MenuNavItem,
} from "./styles";

//css-tricks.com/hamburger-menu-with-a-side-of-react-hooks-and-styled-components/#top-of-site
export const BurgerMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const node = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "scroll";
    }
  }, [menuOpen]);

  useOnClickOutside(node, (e) => {
    setMenuOpen(false);
  });

  return (
    <BurgerMenuContainer ref={node}>
      <BurgerButton menuOpen={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
        <div className="bar1" />
        <div className="bar2" />
        <div className="bar3" />
      </BurgerButton>
      <MenuContainer open={menuOpen}>
        <Menu>
          <MenuNavItem to={homePath} onClick={() => setMenuOpen(false)}>
            eCircuitMania
          </MenuNavItem>
          <MenuNavItem to={pickemPath} onClick={() => setMenuOpen(false)}>
            Pick'em
          </MenuNavItem>
          <MenuNavItem to={matchesPath} onClick={() => setMenuOpen(false)}>
            Matches
          </MenuNavItem>
          <MenuNavItem to={tournamentsPath} onClick={() => setMenuOpen(false)}>
            Tournaments
          </MenuNavItem>
          <MenuNavItem to={tracksPath} onClick={() => setMenuOpen(false)}>
            Tracks
          </MenuNavItem>
          <MenuNavItem to={communityPath} onClick={() => setMenuOpen(false)}>
            Community
          </MenuNavItem>
          <MenuNavItem to={aboutUsPath} onClick={() => setMenuOpen(false)}>
            About Us
          </MenuNavItem>
        </Menu>
      </MenuContainer>
    </BurgerMenuContainer>
  );
};
